import React, {useEffect, useState} from "react";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {PageHeader} from "../../../components/PageHeader";
import {InspectionListType} from "./subPages/InspectionListType";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getInspectionList} from "../../../api/maintenance/InspectionService";
import MaintenanceListThumbType from "../MaintenanceListThumbType";
import MobileCreateButton from "../../../components/buttons/MobileCreateButton";
import {CHART_REGISTRY} from "../../../components/AiComponents/ChartRegistry";

function InspectionList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const [listType, setListType] = useState(true)
    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    const { data, newData, pageInfo, dataHook} =
        useRequestData(getInspectionList, initDate, "inspection");

    return (
        <>
            <div className="common-container">
                <PageHeader header={`점검등록관리`} indicator={`유지보수업무 > 점검관리 > 점검등록관리`} keys={CHART_REGISTRY.inspection.key} />

                { listType ?
                    <InspectionListType
                        data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                        checked={{checked: checked, setChecked: setChecked}} />
                    :
                    <MaintenanceListThumbType data={data} date={initDate} pageInfo={pageInfo} dataHook={dataHook} type={"inspection"} />
                }
                <MobileCreateButton  url={'/maintenance/inspection/create'} assetCheck />
            </div>
        </>
    );
}

export {InspectionList}